import React, { Component } from "react";
import PropTypes from "prop-types";
import { StaffService } from "@services";
import utils from "@utils";
import { Modal } from "../../../components";

class ReassignJobsModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			contacts: [],
			staffReplacementId: "",
			errorStaffReplacementId: false,
		};
	}

	/** limiting the getContacts call while the modal is open. */
	componentDidUpdate(prevProp) {
		const { showReassignJobsModal } = this.props;
		if (showReassignJobsModal && prevProp.showReassignJobsModal !== showReassignJobsModal) {
			this.getContacts();
		}
	}

	/**
	 * Input change functionalty to get the replacement ID
	 * @param {Event} event triggered on inputChange to get the replacement.
	 */
	handleInputChange = event => {
		const {
			target: { value },
		} = event;
		this.setState({
			staffReplacementId: value,
			errorStaffReplacementId: value === "",
		});
	};

	/** Filtering the list by staffAdmin only, in order to prevent issues with permissions when attempting to edit/duplicate the job. */
	getContacts = () => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id: organizationId },
			},
		} = this.props;
		StaffService.getStaff({ organizationId })
			.then(({ data: { ItemList } }) => {
				const contacts = ItemList?.filter(
					item => item.IsAdmin === true && item.UserId !== 0,
				).map(contact => ({
					label: contact.ContactName,
					value: contact.Id,
				}));
				this.setState({ contacts });
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error Getting Organization Staff"),
					timeOut: 1500,
				}),
			);
	};

	/** Re-assigning staff members with a replacement ID and sending the updated Staff list back to staff.js to update the page. */
	reassignJob = () => {
		const { lang } = global;
		const { staffReplacementId } = this.state;
		const { closeModal, staffId, staff } = this.props;

		const data = staff.filter(member => member.Id !== staffId);

		this.setState({
			errorStaffReplacementId: staffReplacementId === "",
		});

		if (staffReplacementId) {
			StaffService.replaceStaff(staffId, staffReplacementId)
				.then(() => {
					utils.notify({
						type: "success",
						message: lang.t("Staff member deleted"),
						timeOut: 2000,
					});
					closeModal({ data });
				})
				.catch(() => {
					utils.notify({
						type: "error",
						message: lang.t("Error deleting staff member"),
						timeOut: 1500,
					});
				});
		}
	};

	render() {
		const { lang } = global;
		const { closeModal, showReassignJobsModal, staff, staffId } = this.props;
		const { contacts, staffReplacementId, errorStaffReplacementId } = this.state;
		const staffMember = staff.find(member => member.Id === staffId);

		return (
			<Modal
				show={showReassignJobsModal}
				onHide={closeModal}
				id="jobs-reassign-modal"
			>
				<Modal.Header>
					<Modal.Title>{lang.t("Reassign Jobs")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row form-group">
						<If condition={staffMember}>
							<p className="col-sm-12">
								{lang.t(
									"dynamic.Please select a user to supervise jobs currently assigned to",
									{ name: `${staffMember.FirstName} ${staffMember.LastName}` },
								)}
							</p>
						</If>
						<div className="col-sm-12">
							<select
								id="staff-member-replacement"
								className="form-control"
								value={staffReplacementId}
								onChange={event => this.handleInputChange(event)}
							>
								<option value="">--</option>
								<For
									each="item"
									of={contacts}
									index="index"
								>
									<option
										key={item.value}
										value={item.value}
									>
										{item.label}
									</option>
								</For>
							</select>
						</div>
						<If condition={errorStaffReplacementId === true}>
							<div className="text-danger col-sm-12">
								{lang.t("Please select a supervisor")}
							</div>
						</If>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						onClick={closeModal}
						className="btn btn-link"
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						onClick={() => this.reassignJob()}
						className="btn btn-primary"
					>
						{lang.t("Reassign")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}
ReassignJobsModal.propTypes = {
	closeModal: PropTypes.func,
	user: PropTypes.object,
	showReassignJobsModal: PropTypes.bool,
	staffId: PropTypes.number,
	staff: PropTypes.array,
};
ReassignJobsModal.defaultProps = {
	closeModal: () => {},
	user: {},
	showReassignJobsModal: false,
	staffId: undefined,
	staff: [],
};

export default ReassignJobsModal;
